import {useCachePreheatQueries, useCachePreheatQuery} from '@github-ui/relay-query-cache/hooks/use-cache-preheat-query'
import {useMemo} from 'react'

import {IssueViewerViewGraphqlQuery} from '../components/IssueViewer'
import {IssueViewerSecondaryGraphqlQuery} from '../components/IssueViewerSecondaryView'

type UseCachePreheatIssueViewerProps = {
  owner: string
  repo: string
  number: number
  source: string
}

type UseCachePreheatIssueViewerQueriesProps = {
  issues: Array<{
    owner: string
    repo: string
    number: number
  }>
  source: string
}

export function useCachePreheatIssueViewer({owner, repo, number, source}: UseCachePreheatIssueViewerProps) {
  const excludeFromSecondaryQueryCacheKey = useMemo(() => ['markAsRead'], [])

  useCachePreheatQuery({
    query: IssueViewerViewGraphqlQuery,
    variables: {
      owner,
      repo,
      number,
      count: 15,
    },
    source,
    highPriority: true,
  })

  useCachePreheatQuery({
    query: IssueViewerSecondaryGraphqlQuery,
    variables: {
      owner,
      repo,
      number,
      markAsRead: false,
    },
    source,
    excludeFromCacheKey: excludeFromSecondaryQueryCacheKey,
  })
}

export function useCachePreheatIssueViewerQueries({issues, source}: UseCachePreheatIssueViewerQueriesProps) {
  const excludeFromSecondaryQueryCacheKey = useMemo(() => ['markAsRead'], [])

  const queries = useMemo(() => {
    const primaryQueries = issues.map(({owner, repo, number}) => ({
      query: IssueViewerViewGraphqlQuery,
      variables: {
        owner,
        repo,
        number,
        count: 15,
      },
      source,
      highPriority: true,
    }))

    const secondaryQueries = issues.map(({owner, repo, number}) => ({
      query: IssueViewerSecondaryGraphqlQuery,
      variables: {
        owner,
        repo,
        number,
        markAsRead: false,
      },
      source,
      excludeFromCacheKey: excludeFromSecondaryQueryCacheKey,
    }))

    return [...primaryQueries, ...secondaryQueries]
  }, [issues, source, excludeFromSecondaryQueryCacheKey])

  useCachePreheatQueries({queries})
}
